import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConnectionService } from '../../services/connection.service';
import { DataFieldsService } from '../../services/data-fields.service';
import { LoaderService } from '../../services/loader.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-vehicle-proposal-form',
  templateUrl: './vehicle-proposal-form.page.html',
  styleUrls: ['./vehicle-proposal-form.page.scss'],
})
export class VehicleProposalFormPage implements OnInit {
  proposerFilled = "section-btn active-section-btn";
  iciciProposalForm: FormGroup
  showFlagErrorMsg:boolean=false;
  quoteRes: any;
  updtIdv: any;
  getInsurerCount: any;
  quoteId: any;
  getInsurer: any;
  orderId: any;
  inCompleteApplicationData: any;
  appIncompleteData: any;
  redirectUrl: any;
  showSuccessMsg: boolean;
  showErrorMsg: boolean;
  errorDetails: any;
  checkAlert: boolean = false;
  showProposerDetail: boolean = true
  cityList: any;
  stateList: any;
  makeCd: any;
  modelCd: any;
  showbreakinSuccess:boolean=false;
  flagResp: any;
  rsaValue: string;
  engineValue: boolean;
  zdValue: string;
  consValue: boolean;
  rtiValue: boolean;
  keyValue: string;
  lopValue: string;
  garageValue: boolean;
  addons: any;
  errors: any;
  qtreq: any;
  icici_propReq: any
  isBrand: boolean;
  notMand: boolean;
  prevInsurerList: any=[];
  deliveryOrRegDate: any;
  isPrevIns: boolean;
  breakingScenerio: boolean;
  showMain: boolean;
  cityCode: any;
  stateCode: any;
  pinCode: any;
  countryCode: any;
  breakEdit: boolean=true;
  showClose: boolean=false;
  breakInReq: any;
  appResp: any;
  stateName: any;
  cityName: any;
  proposalNo: any;
  adressShow: boolean=true;
  breakinData: any;
  applicationNumber: any;
  hideInfo: any;
  showMsg: any;
  showFail: boolean;
  lombardCkycDetails: any;
  constructor(private fb: FormBuilder,private _dataFields: DataFieldsService, private loader: LoaderService, private _datePipe: DatePipe, private router: Router, private apiService: ConnectionService, private strg: StorageService, private toast: ToastService) { }

  ngOnInit() {
    this.iciciProposalForm = this.fb.group({
      icici_custName: ['', [Validators.required]],
      icici_custDob: ['',[Validators.required]],
      icici_custMobile: ['', [Validators.required, Validators.pattern('[6-9]\\d{9}')]],
      icici_custEmail: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      icici_panNumber: [''],
      icici_custAdhrNumber: [''],
      icici_custAdd: ['', [Validators.required]],
      icici_custState: ['', [Validators.required]],
      icici_custCity: ['', [Validators.required]],
      icici_custCount: ['', [Validators.required]],
      icici_VregNo: ['', [Validators.required]],
      icici_Vchasis: ['', [Validators.required]],
      icici_Vengine: ['', [Validators.required]],
      icici_VdeliveryDate:[''],
      icici_pinCode: ['', [Validators.required]],
      icici_VprePolcyNo:[''],
      icici_VpreInsName:[''],
      icici_gender:[''],
      icici_custAdhrEnrollNo:[''],
      icici_custAccNo:[''],
    })
  }

  ionViewDidEnter() {
    this.prevInsurerList=this._dataFields.getLombardPrevInsurer()   
    this.strg.getStoreData('vhIncp').then(res => {
      if (res) {
        this.getIncompleteApplication()
      }
      else {
        this.getQuoteResId()
        //todo handling
      }
    })
  }
  getQuoteResId() {
    let dataa = {
      "productName": 'ICICI Lombord FW',
      "latest": true
    }
    this.apiService.getQuotesByUserId(dataa).subscribe(res => {
      this.getInsurerCount = JSON.parse(res.data[0].responseParam)
      this.quoteId = res.data[0].id
      this.getInsurer = JSON.parse(res.data[0].insuranceQuoteRequest.reqParam)
      this.qtreq = this.getInsurer.reqParam
      this.isBrand = this.qtreq.isBrandNewVehicle
      this.updtIdv = this.getInsurerCount.responseParam.generalInformation.showRoomPrice
      if(this.getInsurerCount.responseParam.finalPremium > 100000){
        this.iciciProposalForm.get('icici_panNumber').setValidators(Validators.required);
        this.notMand=true;
      }
      else{
        this.notMand=false;
        this.iciciProposalForm.get('icici_panNumber').updateValueAndValidity()
        this.iciciProposalForm.get('icici_panNumber').clearValidators()
      }
      this.iciciProposalForm.get('icici_custName').setValue(this.qtreq.fullName);
      this.iciciProposalForm.get('icici_custMobile').setValue(this.qtreq.mobileNumber);
      this.iciciProposalForm.get('icici_custEmail').setValue(this.qtreq.email);
      this.iciciProposalForm.get('icici_VdeliveryDate').setValue(this.qtreq.vehicleRegistrationDate)
      this.makeCd=this.getInsurerCount.serverQtReq.VehicleMakeCode;
      this.modelCd=this.getInsurerCount.serverQtReq.VehicleModelCode;
      this.isPrevIns=this.getInsurerCount.serverQtReq.IsNoPrevInsurance
      if( this.isBrand === true){
        this.iciciProposalForm.get('icici_VprePolcyNo').clearValidators()
        this.iciciProposalForm.get('icici_VprePolcyNo').updateValueAndValidity()
        this.iciciProposalForm.get('icici_VpreInsName').clearValidators();
        this.iciciProposalForm.get('icici_VpreInsName').updateValueAndValidity();
        if (this.qtreq.vehicleRegistrationNumber != null || this.qtreq.vehicleRegistrationNumber != '') {
          this.iciciProposalForm.get('icici_VregNo').setValue('NEW');
        }
      }
      else if(this.isBrand === false){
        this.iciciProposalForm.get('icici_VregNo').setValue(this.qtreq.vehicleRegistrationNumber);
        if(this.getInsurerCount.serverQtReq.IsNoPrevInsurance){
          this.iciciProposalForm.get('icici_VprePolcyNo').clearValidators()
          this.iciciProposalForm.get('icici_VprePolcyNo').updateValueAndValidity()
          this.iciciProposalForm.get('icici_VpreInsName').clearValidators();
          this.iciciProposalForm.get('icici_VpreInsName').updateValueAndValidity()
        } else {
          this.iciciProposalForm.get('icici_VprePolcyNo').setValidators(Validators.required)
          this.iciciProposalForm.get('icici_VprePolcyNo').updateValueAndValidity()
          this.iciciProposalForm.get('icici_VpreInsName').setValidators(Validators.required)
          this.iciciProposalForm.get('icici_VpreInsName').updateValueAndValidity()
          this.showMain=true;
        }
      }
      let data = {
        "quoteResponseId": this.quoteId
      }
      this.apiService.getApplicationOrderId(data).subscribe(res => {
        this.orderId = res.data.id
      })
      this.autoFillCkycDetailsIfPresent();
    })
  }

  autoFillCkycDetailsIfPresent() {
    this.strg.getStoreData('LombardGenCkycData').then(res => {
      console.log("LombardGenCkycData ressss", res)
      this.lombardCkycDetails = res;
      if(this.lombardCkycDetails.statusMessage === "Success" && this.lombardCkycDetails.kyc_details?.ckyc_number) {
        this.iciciProposalForm.get('icici_custName').setValue(this.lombardCkycDetails.kyc_details.first_name+" "+this.lombardCkycDetails.kyc_details.last_name)
        let dobSplit = (this.lombardCkycDetails.kyc_details.dob).split("-");
        this.iciciProposalForm.get("icici_custDob").patchValue(dobSplit[2]+"-"+dobSplit[1]+"-"+dobSplit[0]);
        this.iciciProposalForm.get('icici_gender').setValue(this.lombardCkycDetails.kyc_details.gender === "M" ? "MALE" : "FEMALE");

        this.iciciProposalForm.get('icici_custAdd').setValue(this.lombardCkycDetails.kyc_details.permanent_address.address_line_1)
        this.iciciProposalForm.get('icici_pinCode').setValue(this.lombardCkycDetails.kyc_details.permanent_address.pin_code)
        this.getCity()
        // this.iciciProposalForm.get('icici_custState').setValue(this.lombardCkycDetails.kyc_details.permanent_address.stateCode)
        // this.iciciProposalForm.get('icici_custCity').setValue(this.lombardCkycDetails.kyc_details.permanent_address.cityCode)
        // this.iciciProposalForm.get('icici_custCount').setValue(this.lombardCkycDetails.kyc_details.permanent_address.countryCode)
      }
    });
  }

  saveApplication() {
    let saveData = {
      "orderId": this.orderId,
      "applicationData": this.iciciProposalForm.value
    }
    this.apiService.saveIncompleteICICIAppData(saveData).subscribe(res => {
    }, err => {
    });
  }
  getIncompleteApplication() {
    this.loader.showLoader();
    this.apiService.getIncompleteICICIAppData().subscribe(res => {
      this.loader.hideLoader();
      if (res) {
        if (res.data.length != 0) {
          let data = res.data[0];
          this.appIncompleteData = JSON.parse(data.parameter);
          console.log("incmplt dataaaa", this.appIncompleteData);
          this.autoFillFormData(this.appIncompleteData);
          this.orderId=data.insuranceOrderHistory.id;
          this.quoteId = data.insuranceOrderHistory.insuranceQuoteResponse.id
        }
      }
    })
  }
  autoFillFormData(autoFillData) {
    if(autoFillData.appSubRequest){
      this.iciciProposalForm.get('icici_custName').setValue(autoFillData.appSubRequest.customerName)
      this.iciciProposalForm.get('icici_custDob').setValue(autoFillData.appSubRequest.dateOfBirth)
      this.iciciProposalForm.get('icici_custMobile').setValue(autoFillData.appSubRequest.mobileNumber)
      this.iciciProposalForm.get('icici_custEmail').setValue(autoFillData.appSubRequest.email)
      this.iciciProposalForm.get('icici_panNumber').setValue(autoFillData.appSubRequest.panCardNo)
      this.iciciProposalForm.get('icici_custAdhrNumber').setValue(autoFillData.appSubRequest.aadharNumber)
      this.iciciProposalForm.get('icici_custAdd').setValue(autoFillData.appSubRequest.addressLine1)
      this.iciciProposalForm.get('icici_pinCode').setValue(autoFillData.appSubRequest.pinCode)
      this.iciciProposalForm.get('icici_VprePolcyNo').setValue(autoFillData.appSubRequest.previousPolicyNumber)
      this.iciciProposalForm.get('icici_VpreInsName').setValue(autoFillData.appSubRequest.previousInsurerName)
      this.iciciProposalForm.get('icici_gender').setValue(autoFillData.appSubRequest.gender)
      this.iciciProposalForm.get('icici_custAdhrEnrollNo').setValue(autoFillData.appSubRequest.aadharEnrollmentNo)
      this.iciciProposalForm.get('icici_custAccNo').setValue(autoFillData.appSubRequest.eiaNumber)
      this.getCity()
      this.iciciProposalForm.get('icici_custState').setValue(autoFillData.appSubRequest.stateCode)
      this.iciciProposalForm.get('icici_custCity').setValue(autoFillData.appSubRequest.cityCode)
      this.iciciProposalForm.get('icici_custCount').setValue(autoFillData.appSubRequest.countryCode)
      this.iciciProposalForm.get('icici_VregNo').setValue(autoFillData.appSubRequest.registrationNumber)
      this.iciciProposalForm.get('icici_Vchasis').setValue(autoFillData.appSubRequest.chassisNumber)
      this.iciciProposalForm.get('icici_Vengine').setValue(autoFillData.appSubRequest.engineNumber)
    }
    else{
      this.iciciProposalForm.setValue(autoFillData)
      this.getCity()
    }
    this.autoFillCkycDetailsIfPresent();
  }
  getCity(event?) {
    let pinCode = this.iciciProposalForm.get('icici_pinCode').value
    this.apiService.lombardGetPin(pinCode).subscribe(res => {
      this.cityList = res.data.pincodeList;
      this.stateList = res.data.stateList;
      this.stateName=res.data.stateList[0].state;
      this.cityName=res.data.cityDistrictList[0].txtCityDistrict;      
  })
  }
  backFromBreak()
  {
    this.breakingScenerio = false;
  }
  routeToMyPolicy(){
    this.router.navigate(['home/policies']);
  }
  routeToDashboard(){
    this.router.navigate(['home/dashboard'])
  }
  submitBreakin(){
    this.breakInReq={
        // "correlationId": "9523e218-ef03-4014-abb8-57f7e2bc22b0",
        "correlationId": this.lombardCkycDetails.apiReqData.correlationId,
        "breakInType": "Break-in Policy lapse",
        "breakInDays": 25,
        "customerName": this.iciciProposalForm.get('icici_custName').value,
        "customerAddress": this.iciciProposalForm.get('icici_custAdd').value,
        "state": this.stateName,
        "city": this.cityName,
        "mobileNumber": this.iciciProposalForm.get('icici_custMobile').value,
        "typeVehicle": "PRIVATE CAR",
        "vehicleMake": this.appResp.appSubRestResponse.generalInformation.manufacturerName,
        "vehicleModel": this.appResp.appSubRestResponse.generalInformation.vehicleModel,
        "manufactureYear": this.appResp.appSubRestResponse.generalInformation.manufacturingYear,
        "registrationNo": this.iciciProposalForm.get('icici_VregNo').value,
        "engineNo": this.iciciProposalForm.get('icici_Vengine').value,
        "chassisNo": this.iciciProposalForm.get('icici_Vchasis').value,
        "subLocation": this.cityName,
        "distributorInterID": "200497280658",
        "distributorName": "Emmet",
        "inspectionType": "NEW",
        // "dealId": "DL-3001/13194097",
        // "dealId": "DL-3005/7570014",
        "dealId": "DL-3001/20165271",
        // "dealId":"DL-3001/A/13194098",
        "proposalNumber":this.proposalNo
    }
    this.apiService.breakinSubmit(this.breakInReq).subscribe(res => {
      this.breakinData=res
      if(res.data.status==='Success'){
        this.breakingScenerio = true;
        this.showbreakinSuccess = true;
        this.adressShow=false;
        this.hideInfo=true;
        this.showFail=false
      }
      else if(res.data.status==='Fail'){
        this.showMsg=res.data.message
         this.adressShow=false;
        this.showbreakinSuccess = true;
        this.showFail=true;
        this.hideInfo=false
      }
      
    },err =>{
      this.adressShow=true
      this.showbreakinSuccess = false;
    })
  }
  editToForm(){
    this.breakEdit=false;
    this.showClose=true;
  }
  closeToForm(){
    this.breakEdit=true;
    this.showClose=false;
  }
  submitForm() {
    this.saveApplication();
    let endDt=this.getInsurerCount.serverQtReq.PolicyEndDate.split("/").join("-")
    let startDt=this.getInsurerCount.serverQtReq.PolicyStartDate.split("/").join("-")
    this.deliveryOrRegDate=this.iciciProposalForm.get('icici_VdeliveryDate').value
    this.addons=this.qtreq.iciciLombardAddOns;
    if(this.qtreq.isBrandNewVehicle===true){
      this.icici_propReq =
      {
        "quoteId": this.quoteId,
        "orderId": this.orderId,
        "businessType": "New Business",
        "customerType": "INDIVIDUAL",
        "policyEndDate":endDt,
        "policyStartDate":startDt,
        "deliveryOrRegistrationDate": this.getInsurerCount.serverQtReq.DeliveryOrRegistrationDate,
        "manufacturingYear": this.getInsurerCount.responseParam.generalInformation.manufacturingYear,
        "firstRegistrationDate": this.getInsurerCount.serverQtReq.FirstRegistrationDate,
        "vehicleMakeCode": this.makeCd,
        "vehicleModelCode": this.modelCd,
        "rtoLocationCode": this.getInsurerCount.responseParam.generalInformation.rtoLocationCode,
        "exShowRoomPrice": Math.trunc(this.updtIdv),
        "isPACoverOwnerDriver": true,
        "tpTenure": this.getInsurerCount.responseParam.generalInformation.tpTenure,
        "tenure": this.getInsurerCount.responseParam.generalInformation.tenure,
        "paCoverTenure": 1,
        "gstToState":"MAHARASHTRA",
        "registrationNumber": this.iciciProposalForm.get('icici_VregNo').value,
        "engineNumber": this.iciciProposalForm.get('icici_Vengine').value,
        "chassisNumber": this.iciciProposalForm.get('icici_Vchasis').value,
        "customerName": this.iciciProposalForm.get('icici_custName').value,
        "dateOfBirth": this.iciciProposalForm.get('icici_custDob').value,
        "pinCode": this.iciciProposalForm.get('icici_pinCode').value,
        "panCardNo": this.iciciProposalForm.get('icici_panNumber').value,
        "email": this.iciciProposalForm.get('icici_custEmail').value,
        "mobileNumber": this.iciciProposalForm.get('icici_custMobile').value,
        "addressLine1": this.iciciProposalForm.get('icici_custAdd').value,
        "countryCode": this.iciciProposalForm.get('icici_custCount').value,
        "stateCode": this.iciciProposalForm.get('icici_custState').value,
        "cityCode": this.iciciProposalForm.get('icici_custCity').value,
        "aadharNumber": this.iciciProposalForm.get('icici_custAdhrNumber').value,
        "correlationId": this.getInsurerCount.responseParam.correlationId,
        "iciciLombardAppSubAddons":this.addons,
        "ckycId": this.lombardCkycDetails.kyc_details.ckyc_number || null,
        "ekycId": this.lombardCkycDetails.kyc_details.ekyc_number || null,
        "pepFlag": this.lombardCkycDetails.apiReqData.pepFlag || false,
        "ilkycReferenceNumber": this.lombardCkycDetails.kyc_details.il_kyc_ref_no || null,
        "correspondingAddressLine1": this.iciciProposalForm.get('icici_custAdd').value,
        "correspondingAddressLine2": null,
        "correspondingCountryCode": this.iciciProposalForm.get('icici_custCount').value,
        "correspondingStateCode": this.iciciProposalForm.get('icici_custState').value,
        "correspondingCityCode": this.iciciProposalForm.get('icici_custCity').value,
        "correspondingPinCode": this.iciciProposalForm.get('icici_pinCode').value,
      }
    }
    else if(this.qtreq.isBrandNewVehicle===false){
      let endDt=this.getInsurerCount.serverQtReq.PolicyEndDate.split("/").join("-")
      if(this.qtreq.isNoPrevInsurance === true){
        this.iciciProposalForm.get('icici_VprePolcyNo').setValue(null);
        this.iciciProposalForm.get('icici_VpreInsName').setValue(null);
      }
      this.icici_propReq =
      {
     "quoteId":this.quoteId,
     "orderId":this.orderId,
     "businessType":"Roll Over",
    //  "dealId":"DL-3001/1484597",
    //  "dealId":"DL-3001/13194097",
    // "dealId": "DL-3005/7570014",
    "dealId": "DL-3001/20165271",
    //  "dealId":"DL-3001/A/13194098",
     "policyStartDate":startDt,
     "policyEndDate":endDt,
     "deliveryOrRegistrationDate":this.getInsurerCount.serverQtReq.DeliveryOrRegistrationDate,
     "manufacturingYear":this.getInsurerCount.responseParam.generalInformation.manufacturingYear,
     "vehicleMakeCode":this.makeCd,
     "vehicleModelCode":this.modelCd,
     "rtoLocationCode":this.getInsurerCount.responseParam.generalInformation.rtoLocationCode,
     "registrationNumber":this.iciciProposalForm.get('icici_VregNo').value,
     "exShowRoomPrice":Math.trunc(this.updtIdv),
     "isNoPrevInsurance":this.isPrevIns,
     "isPACoverOwnerDriver":true,
     "gstToState":"MAHARASHTRA",
     "engineNumber" : this.iciciProposalForm.get('icici_Vengine').value,
     "chassisNumber" : this.iciciProposalForm.get('icici_Vchasis').value,
     "previousPolicyStartDate":this.qtreq.previousPolicyStartDate,
     "previousPolicyEndDate":this.qtreq.previousPolicyEndDate,
     "previousPolicyType":"Comprehensive Package",
     "bonusOnPreviousPolicy":"25",
     "claimOnPreviousPolicy":false,
     "previousPolicyNumber":this.iciciProposalForm.get('icici_VprePolcyNo').value,
     "previousInsurerName":this.iciciProposalForm.get('icici_VpreInsName').value,
     "customerType":"INDIVIDUAL",
     "customerName":this.iciciProposalForm.get('icici_custName').value,
     "dateOfBirth":this.iciciProposalForm.get('icici_custDob').value,
     "pinCode":this.iciciProposalForm.get('icici_pinCode').value,
     "panCardNo":this.iciciProposalForm.get('icici_panNumber').value,
     "email":this.iciciProposalForm.get('icici_custEmail').value,
     "mobileNumber":this.iciciProposalForm.get('icici_custMobile').value,
     "addressLine1":this.iciciProposalForm.get('icici_custAdd').value,
     "countryCode":this.iciciProposalForm.get('icici_custCount').value,
     "stateCode":this.iciciProposalForm.get('icici_custState').value,
     "cityCode":this.iciciProposalForm.get('icici_custCity').value,
     "gender":this.iciciProposalForm.get('icici_gender').value,
     "mobileISD":"91",
     "gstDetails":null,
     "aadharNumber":this.iciciProposalForm.get('icici_custAdhrNumber').value,
     "isCollectionofform60":false,
     "aadharEnrollmentNo":this.iciciProposalForm.get('icici_custAdhrEnrollNo').value,
     "eIA_Number":this.iciciProposalForm.get('icici_custAccNo').value,
     "correlationId": this.lombardCkycDetails.apiReqData.correlationId,
     "iciciLombardAppSubAddons":this.addons,
      "ckycId": this.lombardCkycDetails.kyc_details.ckyc_number || null,
      "ekycId": this.lombardCkycDetails.kyc_details.ekyc_number || null,
      "pepFlag": this.lombardCkycDetails.apiReqData.pepFlag || false,
      "ilkycReferenceNumber": this.lombardCkycDetails.kyc_details.il_kyc_ref_no || null,
      "correspondingAddressLine1": this.iciciProposalForm.get('icici_custAdd').value,
      "correspondingAddressLine2": null,
      "correspondingCountryCode": this.iciciProposalForm.get('icici_custCount').value,
      "correspondingStateCode": this.iciciProposalForm.get('icici_custState').value,
      "correspondingCityCode": this.iciciProposalForm.get('icici_custCity').value,
      "correspondingPinCode": this.iciciProposalForm.get('icici_pinCode').value,
    }
    }
     
     this.loader.showLoader()
     setTimeout(()=>{
      this.apiService.lombardSubmitApplication(this.icici_propReq).subscribe(res => {
        this.loader.hideLoader()
        let data = JSON.parse(res.data);
        this.proposalNo=data.appSubRestResponse.generalInformation.proposalNumber
        let repState=this.qtreq.cityRTO.replace('-',' ')
        let spState=repState.split(" ")
        this.appResp=data
        this.cityCode = this.cityList[0].txtPincodeLocality;
        this.stateCode=spState[1];
        this.pinCode=this.iciciProposalForm.get('icici_pinCode').value
        this.applicationNumber=this.appResp.appSubRestResponse.generalInformation.proposalNumber
        this.countryCode="India"
        if (data.redirectUrl && data.appSubRestResponse.breakingFlag===false && data.appSubRestResponse.isApprovalRequired===false && data.appSubRestResponse.isQuoteDeviation===false) {
          this.redirectUrl = data.redirectUrl
          this.showSuccessMsg = true;
          this.strg.setStoreData('starFormPassed', true)
          this.strg.setStoreData('starRedirect', data.redirectUrl)
          this.showErrorMsg = false;
          this.showProposerDetail = false;
        }
        else if(data.appSubRestResponse.breakingFlag === true){
          this.breakingScenerio = true;
          this.showSuccessMsg=false;
          this.showErrorMsg=false;
          this.showFlagErrorMsg=false;
        }
        else {
          this.loader.hideLoader();
          this.errorDetails = data.appSubRestResponse.details
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
          this.showProposerDetail = false;
        }
      }, err => {
        this.loader.hideLoader();
        this.strg.setStoreData('hlIncp', true)
        this.errorDetails      
        if(err.error.message){
          this.showErrorMsg = true;
          this.errors=JSON.parse(err.error.message).message
        }
        else{
          this.showErrorMsg = true;
          this.errors="Internal Server error"
        }
        this.showSuccessMsg = false;
        this.showProposerDetail = false;
      })
    },2000);
   
  }
  proceedToPayment() {
    window.open(this.redirectUrl, "_self")
  }
  closeToApp(){
    this.showSuccessMsg=false;
    this.showProposerDetail=true
  }
  backBtn(){
    this.showProposerDetail=true;
    this.showErrorMsg=false;
    this.showSuccessMsg=false;
  }

  validateLettersOnly(event) {
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }
}